export default __webpack_public_path__ + "static/media/accountAggregatorStatus@2x.5659c067.png";